import React, {FC, useEffect, useState} from 'react';
import GatewayService from "../../service/GatewayService";
import {Feed} from "../../models/Feed";
import {Exchange} from "../../models/Exchange";
import AppConstants from "../../util/AppConstants";
import {TradeBook} from "../../models/TradeBook";
import AppUtil from "../../util/AppUtil";
// @ts-ignore
// import faker from 'faker';


const ExchangeComponent:FC = () => {
    const [data, setData] = useState<Array<TradeBook>>([])
    const [isin, setIsin] = useState("IN0020190537")
    const [refresh, setRefresh] = useState(true)
    const [onlyHoldings, setOnlyHoldings] = useState("no")
    const sorter = (sortBy: string) => {
        const isAsc = AppConstants.sorterMap.get(sortBy) || false
        // @ts-ignore
        defaultSorter = (a, b)=>isAsc?a[sortBy]-b[sortBy] : b[sortBy] - a[sortBy]
        AppConstants.sorterMap.set(sortBy, !isAsc)
        setRefresh(!refresh)
    }
    useEffect(()=>{
        feed()
    },[])
    function feed() {
        let cumm = 0
        let vol = 0
        GatewayService.getTrades(isin, onlyHoldings==="yes").then(books => {
            books.forEach(book=>{
                cumm += book.quantity
                vol += book.quantity*book.price
                book.cumm = cumm
                book.avg = (vol/cumm)
            })
            return books
        } ).then(setData).catch(console.error)
    }
    let qty = data.map(it=>it.quantity).reduce(AppUtil.sum, 0)
    let vol = data.map(it=>it.quantity*it.price).reduce(AppUtil.sum, 0)
    return<>
        <input type="text" value={isin} onChange={event => setIsin((event.target.value))}/>
        <input type="text" value={onlyHoldings} onChange={event => setOnlyHoldings((event.target.value))}/>
        <button onClick={()=>feed()}>refresh</button>
        <table className={"full"}>
            <thead>
            <tr>
                <th>symbol</th>
                <th>price</th>
                <th>qty</th>
                <th>date</th>
                <th>cumm qty</th>
                <th>avg price</th>
            </tr>
            </thead>
            <tbody>
            {data.map(book =>
            <>
                <tr>
                    <td>{book.symbol}</td>
                    <td>{book.price}</td>
                    <td>{book.quantity}</td>
                    <td>{book.trade_date}</td>
                    <td>{book.cumm}</td>
                    <td>{book.avg.toFixed(2)}</td>
                </tr>
            </>

            )}

            <tr>
                <td>-</td>
                <td>{qty}</td>
                <td>{(vol/qty).toFixed(2)}</td>
                <td>{vol}</td>
            </tr>
            </tbody>
        </table>    </>
}

export default ExchangeComponent